//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextSection from "../sections/text-section";
import BrowserMixin from "../../../shared/utils/application-mixins/browser-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SlideSection",
  components: {
    TextSection
  },
  mixins: [BrowserMixin],
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    max: {
      type: [String, Number],
      default: null
    },
    min: {
      type: [String, Number],
      default: null
    },
    disabled: Boolean,
    readOnly: Boolean,
    containerClass: {
      type: String,
      default: ""
    },
    value: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    nameSlide() {
      return `${this.name}-slide`;
    },
    gradient() {
      const {
        value,
        min,
        max,
        disabled,
        readOnly
      } = this;
      const useGreyScale = disabled || readOnly;
      const fromColor = useGreyScale ? "#f3f3f3" : "var(--primary)";
      const toColor = useGreyScale ? "#9a9a9a" : "var(--secondary)";
      const position = (value - min) / (max - min) * 100;
      return `linear-gradient(to right, ${fromColor}, ${toColor} ${position}% , #dddddd ${position}%)`;
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    }
  }
});